var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Avatar from 'material-ui/Avatar';
import FlatButton from 'material-ui/FlatButton';

import HeaderMenu from './HeaderMenu';
import HeaderMenuItem from './HeaderMenuItem';
import addD2Context from '../../component-helpers/addD2Context';
import getBaseUrlFromD2ApiUrl from '../utils/getBaseUrlFromD2ApiUrl';
import styles from '../header-bar-styles';

var getBaseUrl = getBaseUrlFromD2ApiUrl;

var ProfileMenu = addD2Context(function (props, _ref) {
    var d2 = _ref.d2;
    var currentUser = props.currentUser,
        items = props.items;

    var menuItems = items.map(function (item, index) {
        return React.createElement(HeaderMenuItem, _extends({ key: index }, item));
    });

    if (!currentUser.firstName) {
        return React.createElement('div', null);
    }

    var initials = '' + currentUser.firstName.charAt(0) + currentUser.surname.charAt(0);
    var rightSide = React.createElement(
        'div',
        { style: styles.profileRightSide },
        React.createElement(
            'div',
            { style: styles.profileFlexWrap },
            React.createElement(
                Avatar,
                { size: 60, style: styles.avatarBig },
                initials
            ),
            React.createElement(
                'div',
                null,
                React.createElement(
                    'div',
                    { key: name, style: styles.profileName },
                    currentUser.displayName
                ),
                React.createElement(
                    'div',
                    { style: styles.profileMail },
                    currentUser.email
                )
            )
        ),
        React.createElement(
            FlatButton,
            { style: styles.logoutButton, href: getBaseUrl(d2) + '/dhis-web-commons-security/logout.action' },
            d2.i18n.getTranslation('log_out')
        )
    );

    return React.createElement(
        HeaderMenu,
        {
            name: React.createElement(
                Avatar,
                { size: 32, style: styles.avatar },
                initials
            ),
            rowItemCount: props.rowItemCount,
            columnItemCount: props.columnItemCount,
            rightSide: rightSide,
            width: 700,
            menuStyle: styles.profileMenu,
            padding: '1rem'
        },
        menuItems
    );
});

export default ProfileMenu;


//////////////////
// WEBPACK FOOTER
// ./~/d2-ui/lib/app-header/menus/ProfileMenu.js
// module id = 526
// module chunks = 13